// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Calendar page – Availability Auditor / Schedule layout */

/* Wrapper: at least viewport height but can grow so page can scroll (no cut-off) */
.calendar-wrapper {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 6rem);
}

.calendar-page {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.calendar-loading-shell {
  border: 1px solid #dbe5ef;
  border-radius: 14px;
  padding: 1.25rem;
  background:
    radial-gradient(circle at 10% 10%, rgba(59, 130, 246, 0.08), transparent 45%),
    radial-gradient(circle at 90% 10%, rgba(16, 185, 129, 0.08), transparent 45%),
    #ffffff;
}

.calendar-loading-hero {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.calendar-loading-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #0d9488;
  box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.45);
  animation: calendarPulse 1.6s infinite;
}

.calendar-loading-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.calendar-loading-subtitle {
  font-size: 0.85rem;
  color: #64748b;
}

.calendar-loading-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.75rem;
}

.calendar-loading-card {
  height: 74px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.shimmer {
  background: linear-gradient(110deg, #f1f5f9 8%, #e2e8f0 18%, #f1f5f9 33%);
  background-size: 200% 100%;
  animation: calendarShimmer 1.4s linear infinite;
}

@keyframes calendarShimmer {
  to {
    background-position-x: -200%;
  }
}

@keyframes calendarPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.45);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(13, 148, 136, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(13, 148, 136, 0);
  }
}

/* ----- Page header: segmented nav outside calendar body, on the left ----- */
.calendar-page-header {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 1rem 0;
}

/* ----- Segmented nav (Availability Auditor | Schedule) ----- */
.calendar-segment-nav {
  display: inline-flex;
  background: #e5e7eb;
  border-radius: 6px;
  padding: 2px;
}

.calendar-segment-nav.nav-2 .nav-link {
  min-width: 0;
}

.calendar-segment-nav .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
  white-space: nowrap;
}

.calendar-segment-nav .nav-link:hover {
  color: #111827;
}

.calendar-segment-nav .nav-link.active {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.calendar-segment-nav .nav-link-icon {
  flex-shrink: 0;
}

.calendar-segment-nav .nav-link .icon-2 {
  width: 1.25rem;
  height: 1.25rem;
}

/* Availability Auditor */
.calendar-body-availability {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1rem;
  align-items: flex-start;
}

@media (min-width: 992px) {
  .calendar-body-availability {
    flex-wrap: nowrap;
  }
}

.availability-left {
  flex-shrink: 0;
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.availability-date-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.availability-date-icon {
  color: #6b7280;
}

.availability-date-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
}

.availability-date-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
}

.availability-calendar-wrap {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.75rem;
}

.availability-calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #111827;
}

.availability-calendar-nav {
  background: none;
  border: none;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  color: #374151;
  font-size: 1.1rem;
  line-height: 1;
}

.availability-calendar-nav:hover {
  color: #0d9488;
}

.availability-calendar-month {
  text-align: center;
  min-width: 140px;
}

.availability-calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  font-size: 0.75rem;
}

.availability-calendar-day-name {
  text-align: center;
  color: #6b7280;
  font-weight: 500;
  padding: 0.2rem 0;
}

.availability-calendar-cell {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  color: #374151;
}

.availability-calendar-cell.other-month {
  color: #9ca3af;
}

.availability-calendar-cell.selected {
  background: #0d9488;
  color: #fff;
  font-weight: 600;
}

.availability-calendar-cell:hover:not(.selected) {
  background: #e5e7eb;
}

.availability-summary {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.availability-summary-block {
  width: 100%;
  border-radius: 8px;
  padding: 0.6rem 0.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.availability-summary-available {
  background: #d1fae5;
  color: #065f46;
}

.availability-summary-confirmed {
  background: #dbeafe;
  color: #1e40af;
}

.availability-summary-booked {
  background: #fee2e2;
  color: #991b1b;
}

.availability-summary-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.availability-summary-count {
  font-size: 1.1rem;
  font-weight: 700;
}

.availability-right {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1.25rem;
  overflow: hidden;
}

.availability-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
}

.availability-subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
}

.availability-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.availability-search-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

.availability-search-input {
  flex: 1 1;
  border: none;
  background: none;
  font-size: 0.9rem;
  color: #111827;
  outline: none;
}

.availability-search-input::placeholder {
  color: #9ca3af;
}

.availability-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.availability-filter-wrap {
  min-width: 140px;
  flex: 1 1;
}

.availability-filter-wrap .mb-3 {
  margin-bottom: 0 !important;
}

.availability-auditor-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.availability-auditor-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  background: #fafafa;
}

.availability-auditor-card--confirmed {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.availability-auditor-card--scheduled {
  background: #fff5f0;
  border-color: #fed7aa;
}

.availability-auditor-card--available {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.availability-auditor-card-main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.availability-auditor-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.availability-auditor-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
}

.availability-auditor-role {
  font-size: 0.8rem;
  color: #6b7280;
}

.availability-auditor-status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 500;
  flex-shrink: 0;
  padding: 0.35em 0.65em;
  border-radius: 0.25rem;
}

.availability-auditor-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.availability-auditor-status-available.badge.bg-success {
  background-color: #198754 !important;
  color: #fff !important;
}

.availability-auditor-status-available .availability-auditor-status-dot {
  background: #198754;
  opacity: 0.9;
}

.availability-auditor-status-scheduled.badge.bg-light {
  background-color: #f8f9fa !important;
  color: #212529 !important;
}

.availability-auditor-status-scheduled .availability-auditor-status-dot {
  background: #dc2626;
}

.availability-auditor-status-confirmed.badge.bg-blue-lt {
  background-color: #dbeafe !important;
  color: #1d4ed8 !important;
}

.availability-auditor-status-confirmed .availability-auditor-status-dot {
  background: #2563eb;
}

.availability-auditor-card--confirmed .availability-auditor-event {
  background: #dbeafe;
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.08);
}

.availability-auditor-event {
  margin-top: 0.75rem;
  padding: 1rem;
  border-radius: 8px;
  border: none;
  background: #ffddd6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.availability-auditor-event-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #4b5563;
}

.availability-auditor-event-row svg {
  color: #6b7280;
  flex-shrink: 0;
}

.availability-auditor-location {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: #ecfdf5;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.availability-auditor-location svg {
  color: #9ca3af;
  flex-shrink: 0;
}

/* ----- Body: height follows calendar-sidebar (main is positioned so it doesn’t drive height) ----- */
.calendar-body {
  flex: 1 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

/* Left sidebar sets body height; main is absolutely positioned to match that height */
@media (min-width: 992px) {
  .calendar-body {
    flex-wrap: nowrap;
    align-items: stretch;
  }
  .calendar-body .calendar-sidebar {
    flex-shrink: 0;
  }
  .calendar-body .calendar-main {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 261px; /* sidebar width + border */
    margin: 1rem;
    width: auto;
    flex: none;
  }
}

/* ----- Left sidebar (wraps with main when calendar-body wraps on small screens) ----- */
.calendar-sidebar {
  width: 260px;
  min-width: 260px;
  flex: 0 1 auto;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
}

/* Add Schedule button + dropdown */
.calendar-add-schedule-wrap {
  position: relative;
}

.calendar-add-schedule-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calendar-add-schedule-btn .icon.open {
  transform: rotate(180deg);
}

.calendar-add-schedule-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow: hidden;
  padding: 0.25rem 0;
}

.calendar-add-schedule-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: none;
  background: none;
  font-size: 0.875rem;
  color: #374151;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;
}

.calendar-add-schedule-item:hover {
  background: #f3f4f6;
}

.calendar-add-schedule-item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--item-color, #6b7280);
  flex-shrink: 0;
}

/* Add Audit Schedule offcanvas – wider width, expands when item selected */
.calendar-offcanvas-audit.offcanvas {
  width: 520px;
  max-width: 95vw;
  transition: width 0.3s ease;
}

.calendar-offcanvas-audit.offcanvas.expanded {
  width: 1000px;
  max-width: 95vw;
}

.calendar-offcanvas-audit .offcanvas-body {
  padding: 1rem;
  flex: 1 1;
  overflow-y: auto;
}

.calendar-offcanvas-audit .offcanvas-footer {
  border-top: 1px solid #e5e7eb;
  padding: 1rem;
  background: #fff;
}

/* Form section (left) and details section (right) */
.calendar-audit-form-section {
  min-width: 0;
}

.calendar-audit-details-section {
  width: 450px;
  min-width: 450px;
  border-left: 1px solid #e5e7eb;
  padding-left: 1.5rem;
  overflow-y: auto;
}

/* Audit items list */
.calendar-audit-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: auto;
}

.calendar-audit-item:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.calendar-audit-item.active {
  background: #eff6ff;
  border-color: #0d9488;
}

.calendar-audit-item-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #9ca3af;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.calendar-audit-item-body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1 1;
  min-width: 0;
}

.calendar-audit-item-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
}

.calendar-audit-item-subtitle {
  font-size: 0.75rem;
  color: #6b7280;
}

.calendar-audit-item-priority {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: #b45309;
  background: #fef3c7;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  flex-shrink: 0;
}

.calendar-audit-priority-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d97706;
}

/* Details section styles */
/* Company card: teal banner, overlapping avatar, name/id, details grid */
.calendar-audit-company-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
}

.calendar-audit-company-banner {
  height: 72px;
  background: #0d9488;
  border-radius: 10px 10px 0 0;
}

.calendar-audit-company-card-body {
  position: relative;
  padding: 0 1rem 1rem;
  background: #fff;
}

.calendar-audit-company-avatar-large {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-top: -28px;
  margin-bottom: 0.75rem;
  border-radius: 10px;
  background: #fff;
  color: #0d9488;
  font-size: 1.125rem;
  font-weight: 700;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.calendar-audit-company-name {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.25rem;
}

.calendar-audit-company-id {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.calendar-audit-company-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 1.5rem;
}

.calendar-audit-detail-label {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.calendar-audit-detail-value {
  display: block;
  font-size: 0.875rem;
  color: #111827;
  word-break: break-word;
}

.calendar-audit-detail-value a,
.calendar-audit-company-details-grid .calendar-audit-detail-value a {
  color: #2563eb;
  text-decoration: underline;
}

.calendar-audit-detail-value a:hover,
.calendar-audit-company-details-grid .calendar-audit-detail-value a:hover {
  color: #1d4ed8;
}

/* Audit details card: title = certification, body = accordion */
.calendar-audit-details-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.calendar-audit-card-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem 1rem;
  font-weight: 600;
}

.calendar-audit-cert-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3182ce;
  flex-shrink: 0;
}

.calendar-audit-cert-text {
  font-size: 0.875rem;
  color: #111827;
  flex: 1 1;
}

.calendar-audit-cert-code {
  font-size: 0.875rem;
  color: #6b7280;
}

.calendar-audit-details-card .accordion-item {
  border-left: none;
  border-right: none;
}

.calendar-audit-details-card .accordion-item:last-child {
  border-bottom: none;
}

.calendar-audit-surveillance-row-inline {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.75rem;
}

.calendar-audit-surveillance-row-inline .calendar-audit-surveillance-row {
  flex: 1 1;
  margin-bottom: 0;
}

.calendar-audit-surveillance-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.calendar-audit-surveillance-row:last-child {
  margin-bottom: 0;
}

/* Mini calendar */
.calendar-mini {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem;
}

.calendar-mini-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
}

.calendar-mini-nav {
  background: none;
  border: none;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  color: #374151;
  font-size: 1.1rem;
  line-height: 1;
}

.calendar-mini-nav:hover {
  color: #0d9488;
}

.calendar-mini-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  font-size: 0.75rem;
}

.calendar-mini-day-name {
  text-align: center;
  color: #6b7280;
  font-weight: 500;
  padding: 0.2rem 0;
}

.calendar-mini-cell {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  color: #374151;
}

.calendar-mini-cell.other-month {
  color: #9ca3af;
}

.calendar-mini-cell.selected {
  background: #0d9488;
  color: #fff;
}

.calendar-mini-cell.today {
  background: #fecaca;
  color: #b91c1c;
}

.calendar-mini-cell.today.selected {
  background: var(--tblr-primary);
  color: #fff;
}

.calendar-mini-cell:hover:not(.selected) {
  background: #e5e7eb;
}

/* Download button */
.calendar-download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 1rem;
  background: #fff;
  border: 1px solid var(--tblr-primary);
  color: var(--tblr-primary);
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
}

.calendar-download-btn:hover {
  background: #ccfbf1;
}

/* Filter section */
.calendar-filter {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.calendar-filter-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.75rem;
  background: none;
  border: none;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

.calendar-filter-toggle svg {
  transition: transform 0.2s;
}

.calendar-filter-toggle svg.open {
  transform: rotate(180deg);
}

.calendar-filter-content {
  padding: 0 0.75rem 0.75rem;
  border-top: 1px solid #e5e7eb;
}

.calendar-filter-section-title {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.calendar-filter-section {
  padding-top: 0.5rem;
}

.calendar-filter-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0;
  font-size: 0.85rem;
  color: #374151;
  cursor: pointer;
}

.calendar-filter-check input {
  margin: 0;
}

.calendar-filter-check .count {
  margin-left: auto;
  color: #6b7280;
  font-size: 0.8rem;
}

.calendar-filter-check.is-active {
  background: rgba(14, 165, 233, 0.08);
  border-radius: 6px;
  padding-inline: 0.35rem;
}

.calendar-filter-meta {
  font-size: 0.76rem;
  color: #64748b;
  margin-bottom: 0.45rem;
}

.calendar-filter-active-labels {
  font-size: 0.75rem;
  color: #0f766e;
  background: rgba(20, 184, 166, 0.12);
  border: 1px solid rgba(20, 184, 166, 0.25);
  border-radius: 6px;
  padding: 0.28rem 0.4rem;
  margin-bottom: 0.45rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-filter-only-btn {
  margin-left: auto;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 0.08rem 0.45rem;
  line-height: 1.3;
}

.calendar-filter-only-btn:hover {
  border-color: #0ea5e9;
  color: #0369a1;
  background: #e0f2fe;
}

/* ----- Main area: on large screens height = sidebar (via body); on small screens normal flex ----- */
.calendar-main {
  flex: 1 1;
  min-width: 280px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  margin: 1rem;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.calendar-toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: #f4f4f5;
  border-bottom: 1px solid #e5e7eb;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.calendar-toolbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.calendar-month-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.calendar-month-nav button {
  background: none;
  border: none;
  padding: 0.25rem 0.5rem;
  font-size: 1.1rem;
  color: #374151;
  cursor: pointer;
}

.calendar-month-nav button:hover {
  color: #0d9488;
}

.calendar-month-label {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  min-width: 140px;
  text-align: center;
}

.calendar-view-tabs {
  display: flex;
  background: #e5e7eb;
  border-radius: 6px;
  padding: 2px;
}

.calendar-view-tab {
  padding: 0.35rem 0.75rem;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #4b5563;
  cursor: pointer;
}

.calendar-view-tab:hover {
  color: #111827;
}

.calendar-view-tab.active {
  background: var(--tblr-primary);
  color: #fff;
}

/* Calendar grid (month view) – scale to fit; min height so page can scroll when needed */
.calendar-grid {
  flex: 1 1;
  min-height: 360px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: auto repeat(6, minmax(0, 1fr));
  overflow: auto;
}

.calendar-grid-header-cell {
  padding: 0.5rem;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
  background: #fafafa;
}

.calendar-grid-header-cell:last-child {
  border-right: none;
}

.calendar-grid-cell {
  border-right: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.35rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.calendar-grid-cell:nth-child(7n) {
  border-right: none;
}

.calendar-grid-cell.other-month {
  background: #fafafa;
}

.calendar-grid-cell.weekend {
  background: #fafafa;
}

.calendar-grid-cell.weekend.other-month {
  background: #fafafa;
}

.calendar-cell-date {
  font-size: 0.85rem;
  color: #374151;
  align-self: flex-end;
  margin-bottom: 0.25rem;
}

.calendar-grid-cell.other-month .calendar-cell-date {
  color: #9ca3af;
}

.calendar-grid-cell.today .calendar-cell-date {
  color: var(--tblr-primary, #0d9488);
  font-weight: 600;
}

.calendar-cell-events {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow: hidden;
}

/* Event list: only visible event(s); rest are in +N more dropdown */
.calendar-cell-events-list {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.calendar-cell-event {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border-left: 3px solid;
  font-size: 0.75rem;
  gap: 0.35rem;
}

.event-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.event-count {
  flex-shrink: 0;
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
}

/* +N more (Outlook-style) – always visible, never cut off; shows count of events that can't be shown */
.calendar-cell-more-wrap {
  flex-shrink: 0;
  margin-top: 0.15rem;
}

.calendar-cell-view-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  padding: 0.15rem 0.35rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #0d9488;
  background: rgba(13, 148, 136, 0.1);
  border: 1px solid rgba(13, 148, 136, 0.3);
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

.calendar-cell-view-more:hover {
  background: rgba(13, 148, 136, 0.15);
  border-color: #0d9488;
}

.calendar-cell-event {
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
}

.calendar-cell-event:hover {
  filter: brightness(0.97);
}

/* Event detail modal – audit dashboard visual language */
.calendar-event-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(7, 35, 43, 0.56);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-sizing: border-box;
}

.calendar-event-modal {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
  max-width: 600px;
  width: 100%;
  max-height: calc(100vh - 3rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.calendar-event-modal-header {
  padding: 1.4rem 4.25rem 1.25rem 1.5rem;
  color: #fff;
  background: linear-gradient(135deg, #0d5962, #1a767e 65%, #2aa5a8);
  position: relative;
  flex-shrink: 0;
}

.calendar-event-modal-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
}

.calendar-event-modal-title {
  margin: 0.35rem 0 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
}

.calendar-event-modal-title-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #9df0d0;
  box-shadow: 0 0 0 3px rgba(157, 240, 208, 0.17);
}

.calendar-event-modal-subtitle {
  margin: 0.4rem 0 0;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.75);
}

.calendar-event-modal-header-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.9rem;
}

.calendar-event-modal-status,
.calendar-event-modal-projects {
  padding: 0.24rem 0.58rem;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.13);
  font-size: 0.72rem;
  font-weight: 600;
  color: #fff;
}

.calendar-event-modal-close {
  position: absolute;
  top: 1.2rem;
  right: 1.25rem;
  width: 2.1rem;
  height: 2.1rem;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.13);
  color: #fff;
  cursor: pointer;
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.calendar-event-modal-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.24);
}

.calendar-event-modal-body {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.calendar-event-modal-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.calendar-event-modal-list-item {
  padding: 1rem;
  background: linear-gradient(135deg, #fff, #f8fbfb);
  border: 1px solid #e2ebeb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(16, 82, 88, 0.04);
}

.calendar-event-modal-item-topline {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
}

.calendar-event-modal-item-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.calendar-event-modal-item-num {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 9px;
  background: #e9f7f4;
  color: #167169;
  font-size: 0.68rem;
  font-weight: 800;
}

.calendar-event-modal-item-title {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1b2b3a;
}

.calendar-event-modal-item-status {
  margin-left: auto;
  padding: 0.18rem 0.48rem;
  border-radius: 99px;
  background: #eaf8f1;
  color: #15805f;
  font-size: 0.67rem;
  font-weight: 700;
}

.calendar-event-modal-item-meta {
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #6b7280;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.calendar-event-modal-item-company {
  font-weight: 600;
}

.calendar-event-modal-item-code {
  color: #0d9488;
}

.calendar-event-modal-item-cert {
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #4b5563;
}

.calendar-event-modal-details {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.9rem;
  margin: 0.75rem 0 0;
  padding-top: 0.7rem;
  border-top: 1px solid #edf1f2;
  font-size: 0.74rem;
  color: #687684;
}

.calendar-event-modal-item-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.8rem;
}

.calendar-event-modal-process-link,
.calendar-event-modal-edit-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.42rem 0.7rem;
  border-radius: 8px;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.calendar-event-modal-process-link {
  border: 1px solid #1a767e;
  background: #1a767e;
  color: #fff;
}

.calendar-event-modal-edit-link {
  border: 1px solid #a7dce0;
  background: #fff;
  color: #14737b;
}

.calendar-event-modal-process-link:hover,
.calendar-event-modal-edit-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(13, 89, 98, 0.16);
}

.calendar-event-modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eef0;
}

@media (max-width: 576px) {
  .calendar-event-modal-backdrop { padding: 0.75rem; }
  .calendar-event-modal-header { padding: 1.2rem 3.7rem 1.05rem 1.1rem; }
  .calendar-event-modal-body { padding: 1rem 1.1rem; }
  .calendar-event-modal-title { font-size: 1.12rem; }
}

/* Dropdown for hidden events (positioned via portal) */
.calendar-more-dropdown {
  position: fixed;
  z-index: 1050;
  min-width: 180px;
  max-width: 280px;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 0.35rem 0;
}

.calendar-more-dropdown-title {
  padding: 0.4rem 0.75rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0.25rem;
}

.calendar-more-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.4rem 0.75rem;
  border: none;
  background: none;
  font-size: 0.8rem;
  color: #374151;
  text-align: left;
  cursor: pointer;
  gap: 0.35rem;
  border-left: 3px solid transparent;
}

.calendar-more-dropdown-item:hover {
  background: #f3f4f6;
}

.calendar-more-dropdown-item .event-label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-more-dropdown-item .event-count {
  flex-shrink: 0;
  padding: 0.1rem 0.35rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
}

.calendar-placeholder {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6b7280;
}

/* ── List View ─────────────────────────────────────────────── */
.calendar-list-view {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.5rem 0 2rem;
}

.calendar-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #9ca3af;
  gap: 0.75rem;
}

.calendar-list-empty-icon {
  opacity: 0.4;
}

.calendar-list-empty-text {
  margin: 0;
  font-size: 0.95rem;
}

.calendar-list-month-group {
  margin-bottom: 1.5rem;
}

.calendar-list-month-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
  padding: 0.4rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
}

.calendar-list-day-group {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #f3f4f6;
}

.calendar-list-day-label {
  flex: 0 0 90px;
  padding: 0.6rem 0.75rem 0.6rem 1rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  line-height: 1.4;
}

.calendar-list-day-events {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.4rem 1rem 0.4rem 0;
}

.calendar-list-event-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  border: none;
  background: var(--ev-bg, #f3e8ff);
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: filter 0.12s;
  border-left: 3px solid var(--ev-color, #7c3aed);
}

.calendar-list-event-row:hover {
  filter: brightness(0.96);
}

.calendar-list-event-dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ev-color, #7c3aed);
}

.calendar-list-event-label {
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--ev-color, #7c3aed);
  white-space: nowrap;
  background: transparent;
}

.calendar-list-event-title {
  flex: 1 1;
  font-size: 0.82rem;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-list-event-count {
  flex: 0 0 auto;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--ev-color, #7c3aed);
  background: transparent;
  white-space: nowrap;
}

/* ----- Week view: max height follows calendar-main; body fills and overflows ----- */
.calendar-week-view {
  --week-grid-height: 2304px; /* 48 slots × 48px for 24h in 30-min increments */
  flex: 1 1;
  min-height: 0;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.calendar-week-header {
  display: flex;
  flex-shrink: 0;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
  z-index: 2;
  position: relative;
  /* Match week-body width: reserve space for vertical scrollbar so day columns align */
  padding-right: var(--scrollbar-gutter-width, 17px);
  box-sizing: border-box;
}

.calendar-week-time-col {
  width: 52px;
  min-width: 52px;
  flex-shrink: 0;
  border-right: 1px solid #e5e7eb;
  padding: 0.5rem 0.25rem;
  font-size: 0.75rem;
  color: #6b7280;
  text-align: right;
}

.calendar-week-day-col {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.25rem;
  border-right: 1px solid #e5e7eb;
  gap: 0.15rem;
}

.calendar-week-day-col:last-child {
  border-right: none;
}

.calendar-week-day-col.today {
  background: #ecfdf5;
}

.calendar-week-day-name {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
}

.calendar-week-day-num {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
}

.calendar-week-day-col.today .calendar-week-day-num {
  color: var(--tblr-primary, #0d9488);
}

/* All-day row */
.calendar-week-allday {
  display: flex;
  flex-shrink: 0;
  min-height: 36px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.calendar-week-allday-col {
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.25rem 4px;
  gap: 0.2rem;
}

.calendar-week-event-allday {
  width: 100%;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  border-left: 3px solid;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Week body: full height of calendar-week-view so week-view overflows here (scroll inside) */
.calendar-week-body {
  flex: 1 1;
  min-height: 200px;
  display: flex;
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
  background: #fff;
  align-items: flex-start;
  -webkit-overflow-scrolling: touch;
  /* Reserve space for scrollbar so header and body column widths match */
  scrollbar-gutter: stable;
  box-sizing: border-box;
}

.calendar-week-body > .calendar-week-time-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
  height: var(--week-grid-height);
  min-height: var(--week-grid-height);
}

.calendar-week-time-slot {
  height: 96px; /* 2 × 30-min slots to align with grid */
  min-height: 96px;
  padding-right: 0.35rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.calendar-week-time-slot .calendar-week-time-label {
  font-size: 0.7rem;
  color: #9ca3af;
}

.calendar-week-allday .calendar-week-time-label {
  font-size: 0.7rem;
  color: #9ca3af;
  padding: 0.25rem 0.35rem 0 0;
}

.calendar-week-grid {
  flex: 1 1;
  min-width: 0;
  height: var(--week-grid-height);
  min-height: var(--week-grid-height);
  flex-shrink: 0;
  display: flex;
  position: relative;
}

.calendar-week-day-grid {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
}

.calendar-week-day-grid:last-child {
  border-right: none;
}

.calendar-week-slot {
  height: 48px;
  min-height: 48px;
}

/* Full-width 30-min separators: one line from time col across all day columns */
.calendar-week-separators {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--week-grid-height);
  pointer-events: none;
  z-index: 0;
  background: repeating-linear-gradient(
    to bottom,
    transparent 0,
    transparent 47px,
    #e5e7eb 47px,
    #e5e7eb 48px
  );
}

.calendar-week-day-grid.today .calendar-week-slot {
  background: #fafafa;
}

/* Events overlay – full content height so it scrolls with the grid */
.calendar-week-events-layer {
  position: absolute;
  top: 0;
  left: 52px;
  right: 0;
  height: var(--week-grid-height);
  pointer-events: none;
}

.calendar-week-events-layer > * {
  pointer-events: auto;
}

.calendar-week-event-timed {
  position: absolute;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border-left: 3px solid;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  cursor: pointer;
  pointer-events: auto;
  box-sizing: border-box;
  /* Inset by 2px horizontal / 1px vertical so events stay inside grid (set via inline left/top/width/height) */
}

.calendar-week-event-title {
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-week-event-time {
  font-size: 0.65rem;
  color: #4b5563;
  white-space: nowrap;
}

/* Current time line – wrapper matches events layer so % positioning is correct */
.calendar-week-now-line-wrapper {
  position: absolute;
  top: 0;
  left: 52px;
  right: 0;
  height: var(--week-grid-height);
  pointer-events: none;
  z-index: 2;
}

.calendar-week-now-line {
  position: absolute;
  height: 2px;
  background: #dc2626;
  pointer-events: none;
  box-sizing: border-box;
}

.calendar-week-now-line::before {
  content: '';
  position: absolute;
  left: -6px;
  top: -3px;
  width: 8px;
  height: 8px;
  background: #dc2626;
  border-radius: 50%;
}

/* ── Date cell: quick-add button ── */
.calendar-cell-date-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  min-height: 20px;
}

.calendar-cell-date-row .calendar-cell-date {
  align-self: auto;
  margin-bottom: 0;
}

.calendar-cell-add-btn {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  background: none;
  border: 1.5px solid #7c3aed;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7c3aed;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.calendar-grid-cell:hover .calendar-cell-add-btn {
  opacity: 1;
  pointer-events: auto;
}

.calendar-cell-add-btn:hover {
  background: #7c3aed;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Calendar/Calendar.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB;;;WAGS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,sGAAsG;AACtG;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA,sFAAsF;AACtF;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW,EAAE,2BAA2B;IACxC,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;AACF;;AAEA,yFAAyF;AACzF;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B,yEAAyE;AACzE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sGAAsG;AACtG;EACE,SAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA,yFAAyF;AACzF;EACE,SAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uGAAuG;AACvG;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,kEAAkE;EAClE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,cAAc;EACd,UAAU;EACV,0CAA0C;EAC1C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC,gBAAgB,EAAE;EACnD,+BAA+B,qCAAqC,EAAE;EACtE,6BAA6B,oBAAoB,EAAE;EACnD,8BAA8B,kBAAkB,EAAE;AACpD;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sFAAsF;AACtF;EACE,0BAA0B,EAAE,iDAAiD;EAC7E,SAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,qFAAqF;EACrF,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6FAA6F;AAC7F;EACE,SAAW;EACX,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,uEAAuE;EACvE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,YAAY,EAAE,wCAAwC;EACtD,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;EACV;;;;;;GAMC;AACH;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,6GAA6G;AAC/G;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* Calendar page – Availability Auditor / Schedule layout */\n\n/* Wrapper: at least viewport height but can grow so page can scroll (no cut-off) */\n.calendar-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 6rem);\n}\n\n.calendar-page {\n  flex: 1 1 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n}\n\n.calendar-loading-shell {\n  border: 1px solid #dbe5ef;\n  border-radius: 14px;\n  padding: 1.25rem;\n  background:\n    radial-gradient(circle at 10% 10%, rgba(59, 130, 246, 0.08), transparent 45%),\n    radial-gradient(circle at 90% 10%, rgba(16, 185, 129, 0.08), transparent 45%),\n    #ffffff;\n}\n\n.calendar-loading-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  margin-bottom: 1rem;\n}\n\n.calendar-loading-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  background: #0d9488;\n  box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.45);\n  animation: calendarPulse 1.6s infinite;\n}\n\n.calendar-loading-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.calendar-loading-subtitle {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.calendar-loading-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.75rem;\n}\n\n.calendar-loading-card {\n  height: 74px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.shimmer {\n  background: linear-gradient(110deg, #f1f5f9 8%, #e2e8f0 18%, #f1f5f9 33%);\n  background-size: 200% 100%;\n  animation: calendarShimmer 1.4s linear infinite;\n}\n\n@keyframes calendarShimmer {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n@keyframes calendarPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.45);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(13, 148, 136, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(13, 148, 136, 0);\n  }\n}\n\n/* ----- Page header: segmented nav outside calendar body, on the left ----- */\n.calendar-page-header {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 0 1rem 0;\n}\n\n/* ----- Segmented nav (Availability Auditor | Schedule) ----- */\n.calendar-segment-nav {\n  display: inline-flex;\n  background: #e5e7eb;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.calendar-segment-nav.nav-2 .nav-link {\n  min-width: 0;\n}\n\n.calendar-segment-nav .nav-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4b5563;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.calendar-segment-nav .nav-link:hover {\n  color: #111827;\n}\n\n.calendar-segment-nav .nav-link.active {\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.calendar-segment-nav .nav-link-icon {\n  flex-shrink: 0;\n}\n\n.calendar-segment-nav .nav-link .icon-2 {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Availability Auditor */\n.calendar-body-availability {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  padding: 1rem;\n  align-items: flex-start;\n}\n\n@media (min-width: 992px) {\n  .calendar-body-availability {\n    flex-wrap: nowrap;\n  }\n}\n\n.availability-left {\n  flex-shrink: 0;\n  width: 280px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.availability-date-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.availability-date-icon {\n  color: #6b7280;\n}\n\n.availability-date-label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.availability-date-value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.availability-calendar-wrap {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0.75rem;\n}\n\n.availability-calendar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.availability-calendar-nav {\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  color: #374151;\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.availability-calendar-nav:hover {\n  color: #0d9488;\n}\n\n.availability-calendar-month {\n  text-align: center;\n  min-width: 140px;\n}\n\n.availability-calendar-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n  font-size: 0.75rem;\n}\n\n.availability-calendar-day-name {\n  text-align: center;\n  color: #6b7280;\n  font-weight: 500;\n  padding: 0.2rem 0;\n}\n\n.availability-calendar-cell {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: #374151;\n}\n\n.availability-calendar-cell.other-month {\n  color: #9ca3af;\n}\n\n.availability-calendar-cell.selected {\n  background: #0d9488;\n  color: #fff;\n  font-weight: 600;\n}\n\n.availability-calendar-cell:hover:not(.selected) {\n  background: #e5e7eb;\n}\n\n.availability-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.availability-summary-block {\n  width: 100%;\n  border-radius: 8px;\n  padding: 0.6rem 0.75rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.availability-summary-available {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.availability-summary-confirmed {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.availability-summary-booked {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.availability-summary-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.availability-summary-count {\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.availability-right {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1.25rem;\n  overflow: hidden;\n}\n\n.availability-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.availability-subtitle {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.availability-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.availability-search-icon {\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.availability-search-input {\n  flex: 1;\n  border: none;\n  background: none;\n  font-size: 0.9rem;\n  color: #111827;\n  outline: none;\n}\n\n.availability-search-input::placeholder {\n  color: #9ca3af;\n}\n\n.availability-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.availability-filter-wrap {\n  min-width: 140px;\n  flex: 1;\n}\n\n.availability-filter-wrap .mb-3 {\n  margin-bottom: 0 !important;\n}\n\n.availability-auditor-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.availability-auditor-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1rem;\n  background: #fafafa;\n}\n\n.availability-auditor-card--confirmed {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n}\n\n.availability-auditor-card--scheduled {\n  background: #fff5f0;\n  border-color: #fed7aa;\n}\n\n.availability-auditor-card--available {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n}\n\n.availability-auditor-card-main {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.availability-auditor-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.availability-auditor-name {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.availability-auditor-role {\n  font-size: 0.8rem;\n  color: #6b7280;\n}\n\n.availability-auditor-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  flex-shrink: 0;\n  padding: 0.35em 0.65em;\n  border-radius: 0.25rem;\n}\n\n.availability-auditor-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.availability-auditor-status-available.badge.bg-success {\n  background-color: #198754 !important;\n  color: #fff !important;\n}\n\n.availability-auditor-status-available .availability-auditor-status-dot {\n  background: #198754;\n  opacity: 0.9;\n}\n\n.availability-auditor-status-scheduled.badge.bg-light {\n  background-color: #f8f9fa !important;\n  color: #212529 !important;\n}\n\n.availability-auditor-status-scheduled .availability-auditor-status-dot {\n  background: #dc2626;\n}\n\n.availability-auditor-status-confirmed.badge.bg-blue-lt {\n  background-color: #dbeafe !important;\n  color: #1d4ed8 !important;\n}\n\n.availability-auditor-status-confirmed .availability-auditor-status-dot {\n  background: #2563eb;\n}\n\n.availability-auditor-card--confirmed .availability-auditor-event {\n  background: #dbeafe;\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.08);\n}\n\n.availability-auditor-event {\n  margin-top: 0.75rem;\n  padding: 1rem;\n  border-radius: 8px;\n  border: none;\n  background: #ffddd6;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.availability-auditor-event-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #4b5563;\n}\n\n.availability-auditor-event-row svg {\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.availability-auditor-location {\n  margin-top: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  background: #ecfdf5;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.availability-auditor-location svg {\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n/* ----- Body: height follows calendar-sidebar (main is positioned so it doesn’t drive height) ----- */\n.calendar-body {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n/* Left sidebar sets body height; main is absolutely positioned to match that height */\n@media (min-width: 992px) {\n  .calendar-body {\n    flex-wrap: nowrap;\n    align-items: stretch;\n  }\n  .calendar-body .calendar-sidebar {\n    flex-shrink: 0;\n  }\n  .calendar-body .calendar-main {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 261px; /* sidebar width + border */\n    margin: 1rem;\n    width: auto;\n    flex: none;\n  }\n}\n\n/* ----- Left sidebar (wraps with main when calendar-body wraps on small screens) ----- */\n.calendar-sidebar {\n  width: 260px;\n  min-width: 260px;\n  flex: 0 1 auto;\n  background: #ffffff;\n  border-right: 1px solid #e5e7eb;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto;\n}\n\n/* Add Schedule button + dropdown */\n.calendar-add-schedule-wrap {\n  position: relative;\n}\n\n.calendar-add-schedule-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calendar-add-schedule-btn .icon.open {\n  transform: rotate(180deg);\n}\n\n.calendar-add-schedule-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  overflow: hidden;\n  padding: 0.25rem 0;\n}\n\n.calendar-add-schedule-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: none;\n  background: none;\n  font-size: 0.875rem;\n  color: #374151;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.calendar-add-schedule-item:hover {\n  background: #f3f4f6;\n}\n\n.calendar-add-schedule-item-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--item-color, #6b7280);\n  flex-shrink: 0;\n}\n\n/* Add Audit Schedule offcanvas – wider width, expands when item selected */\n.calendar-offcanvas-audit.offcanvas {\n  width: 520px;\n  max-width: 95vw;\n  transition: width 0.3s ease;\n}\n\n.calendar-offcanvas-audit.offcanvas.expanded {\n  width: 1000px;\n  max-width: 95vw;\n}\n\n.calendar-offcanvas-audit .offcanvas-body {\n  padding: 1rem;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.calendar-offcanvas-audit .offcanvas-footer {\n  border-top: 1px solid #e5e7eb;\n  padding: 1rem;\n  background: #fff;\n}\n\n/* Form section (left) and details section (right) */\n.calendar-audit-form-section {\n  min-width: 0;\n}\n\n.calendar-audit-details-section {\n  width: 450px;\n  min-width: 450px;\n  border-left: 1px solid #e5e7eb;\n  padding-left: 1.5rem;\n  overflow-y: auto;\n}\n\n/* Audit items list */\n.calendar-audit-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n  user-select: none;\n  pointer-events: auto;\n}\n\n.calendar-audit-item:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.calendar-audit-item.active {\n  background: #eff6ff;\n  border-color: #0d9488;\n}\n\n.calendar-audit-item-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #9ca3af;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.calendar-audit-item-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.calendar-audit-item-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #111827;\n}\n\n.calendar-audit-item-subtitle {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.calendar-audit-item-priority {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  color: #b45309;\n  background: #fef3c7;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.calendar-audit-priority-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #d97706;\n}\n\n/* Details section styles */\n/* Company card: teal banner, overlapping avatar, name/id, details grid */\n.calendar-audit-company-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 1.5rem;\n}\n\n.calendar-audit-company-banner {\n  height: 72px;\n  background: #0d9488;\n  border-radius: 10px 10px 0 0;\n}\n\n.calendar-audit-company-card-body {\n  position: relative;\n  padding: 0 1rem 1rem;\n  background: #fff;\n}\n\n.calendar-audit-company-avatar-large {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-top: -28px;\n  margin-bottom: 0.75rem;\n  border-radius: 10px;\n  background: #fff;\n  color: #0d9488;\n  font-size: 1.125rem;\n  font-weight: 700;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.calendar-audit-company-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 0.25rem;\n}\n\n.calendar-audit-company-id {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.calendar-audit-company-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem 1.5rem;\n}\n\n.calendar-audit-detail-label {\n  display: block;\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-bottom: 0.25rem;\n}\n\n.calendar-audit-detail-value {\n  display: block;\n  font-size: 0.875rem;\n  color: #111827;\n  word-break: break-word;\n}\n\n.calendar-audit-detail-value a,\n.calendar-audit-company-details-grid .calendar-audit-detail-value a {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.calendar-audit-detail-value a:hover,\n.calendar-audit-company-details-grid .calendar-audit-detail-value a:hover {\n  color: #1d4ed8;\n}\n\n/* Audit details card: title = certification, body = accordion */\n.calendar-audit-details-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.calendar-audit-card-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n}\n\n.calendar-audit-cert-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #3182ce;\n  flex-shrink: 0;\n}\n\n.calendar-audit-cert-text {\n  font-size: 0.875rem;\n  color: #111827;\n  flex: 1;\n}\n\n.calendar-audit-cert-code {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.calendar-audit-details-card .accordion-item {\n  border-left: none;\n  border-right: none;\n}\n\n.calendar-audit-details-card .accordion-item:last-child {\n  border-bottom: none;\n}\n\n.calendar-audit-surveillance-row-inline {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.calendar-audit-surveillance-row-inline .calendar-audit-surveillance-row {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.calendar-audit-surveillance-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.calendar-audit-surveillance-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Mini calendar */\n.calendar-mini {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0.75rem;\n}\n\n.calendar-mini-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.calendar-mini-nav {\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  color: #374151;\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.calendar-mini-nav:hover {\n  color: #0d9488;\n}\n\n.calendar-mini-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n  font-size: 0.75rem;\n}\n\n.calendar-mini-day-name {\n  text-align: center;\n  color: #6b7280;\n  font-weight: 500;\n  padding: 0.2rem 0;\n}\n\n.calendar-mini-cell {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  color: #374151;\n}\n\n.calendar-mini-cell.other-month {\n  color: #9ca3af;\n}\n\n.calendar-mini-cell.selected {\n  background: #0d9488;\n  color: #fff;\n}\n\n.calendar-mini-cell.today {\n  background: #fecaca;\n  color: #b91c1c;\n}\n\n.calendar-mini-cell.today.selected {\n  background: var(--tblr-primary);\n  color: #fff;\n}\n\n.calendar-mini-cell:hover:not(.selected) {\n  background: #e5e7eb;\n}\n\n/* Download button */\n.calendar-download-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  background: #fff;\n  border: 1px solid var(--tblr-primary);\n  color: var(--tblr-primary);\n  border-radius: 6px;\n  font-size: 0.875rem;\n  cursor: pointer;\n}\n\n.calendar-download-btn:hover {\n  background: #ccfbf1;\n}\n\n/* Filter section */\n.calendar-filter {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.calendar-filter-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.6rem 0.75rem;\n  background: none;\n  border: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n.calendar-filter-toggle svg {\n  transition: transform 0.2s;\n}\n\n.calendar-filter-toggle svg.open {\n  transform: rotate(180deg);\n}\n\n.calendar-filter-content {\n  padding: 0 0.75rem 0.75rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.calendar-filter-section-title {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.calendar-filter-section {\n  padding-top: 0.5rem;\n}\n\n.calendar-filter-check {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem 0;\n  font-size: 0.85rem;\n  color: #374151;\n  cursor: pointer;\n}\n\n.calendar-filter-check input {\n  margin: 0;\n}\n\n.calendar-filter-check .count {\n  margin-left: auto;\n  color: #6b7280;\n  font-size: 0.8rem;\n}\n\n.calendar-filter-check.is-active {\n  background: rgba(14, 165, 233, 0.08);\n  border-radius: 6px;\n  padding-inline: 0.35rem;\n}\n\n.calendar-filter-meta {\n  font-size: 0.76rem;\n  color: #64748b;\n  margin-bottom: 0.45rem;\n}\n\n.calendar-filter-active-labels {\n  font-size: 0.75rem;\n  color: #0f766e;\n  background: rgba(20, 184, 166, 0.12);\n  border: 1px solid rgba(20, 184, 166, 0.25);\n  border-radius: 6px;\n  padding: 0.28rem 0.4rem;\n  margin-bottom: 0.45rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.calendar-filter-only-btn {\n  margin-left: auto;\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  color: #475569;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  padding: 0.08rem 0.45rem;\n  line-height: 1.3;\n}\n\n.calendar-filter-only-btn:hover {\n  border-color: #0ea5e9;\n  color: #0369a1;\n  background: #e0f2fe;\n}\n\n/* ----- Main area: on large screens height = sidebar (via body); on small screens normal flex ----- */\n.calendar-main {\n  flex: 1 1 0;\n  min-width: 280px;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  margin: 1rem;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n}\n\n.calendar-toolbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: #f4f4f5;\n  border-bottom: 1px solid #e5e7eb;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.calendar-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.calendar-month-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.calendar-month-nav button {\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  font-size: 1.1rem;\n  color: #374151;\n  cursor: pointer;\n}\n\n.calendar-month-nav button:hover {\n  color: #0d9488;\n}\n\n.calendar-month-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #111827;\n  min-width: 140px;\n  text-align: center;\n}\n\n.calendar-view-tabs {\n  display: flex;\n  background: #e5e7eb;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.calendar-view-tab {\n  padding: 0.35rem 0.75rem;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.calendar-view-tab:hover {\n  color: #111827;\n}\n\n.calendar-view-tab.active {\n  background: var(--tblr-primary);\n  color: #fff;\n}\n\n/* Calendar grid (month view) – scale to fit; min height so page can scroll when needed */\n.calendar-grid {\n  flex: 1 1 0;\n  min-height: 360px;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-template-rows: auto repeat(6, minmax(0, 1fr));\n  overflow: auto;\n}\n\n.calendar-grid-header-cell {\n  padding: 0.5rem;\n  text-align: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #6b7280;\n  border-bottom: 1px solid #e5e7eb;\n  border-right: 1px solid #e5e7eb;\n  background: #fafafa;\n}\n\n.calendar-grid-header-cell:last-child {\n  border-right: none;\n}\n\n.calendar-grid-cell {\n  border-right: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0.35rem;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.calendar-grid-cell:nth-child(7n) {\n  border-right: none;\n}\n\n.calendar-grid-cell.other-month {\n  background: #fafafa;\n}\n\n.calendar-grid-cell.weekend {\n  background: #fafafa;\n}\n\n.calendar-grid-cell.weekend.other-month {\n  background: #fafafa;\n}\n\n.calendar-cell-date {\n  font-size: 0.85rem;\n  color: #374151;\n  align-self: flex-end;\n  margin-bottom: 0.25rem;\n}\n\n.calendar-grid-cell.other-month .calendar-cell-date {\n  color: #9ca3af;\n}\n\n.calendar-grid-cell.today .calendar-cell-date {\n  color: var(--tblr-primary, #0d9488);\n  font-weight: 600;\n}\n\n.calendar-cell-events {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  overflow: hidden;\n}\n\n/* Event list: only visible event(s); rest are in +N more dropdown */\n.calendar-cell-events-list {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.calendar-cell-event {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  border-left: 3px solid;\n  font-size: 0.75rem;\n  gap: 0.35rem;\n}\n\n.event-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.event-count {\n  flex-shrink: 0;\n  padding: 0.1rem 0.35rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n/* +N more (Outlook-style) – always visible, never cut off; shows count of events that can't be shown */\n.calendar-cell-more-wrap {\n  flex-shrink: 0;\n  margin-top: 0.15rem;\n}\n\n.calendar-cell-view-more {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.5rem;\n  padding: 0.15rem 0.35rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #0d9488;\n  background: rgba(13, 148, 136, 0.1);\n  border: 1px solid rgba(13, 148, 136, 0.3);\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.calendar-cell-view-more:hover {\n  background: rgba(13, 148, 136, 0.15);\n  border-color: #0d9488;\n}\n\n.calendar-cell-event {\n  cursor: pointer;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.calendar-cell-event:hover {\n  filter: brightness(0.97);\n}\n\n/* Event detail modal – audit dashboard visual language */\n.calendar-event-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1060;\n  background: rgba(7, 35, 43, 0.56);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  box-sizing: border-box;\n}\n\n.calendar-event-modal {\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);\n  max-width: 600px;\n  width: 100%;\n  max-height: calc(100vh - 3rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.calendar-event-modal-header {\n  padding: 1.4rem 4.25rem 1.25rem 1.5rem;\n  color: #fff;\n  background: linear-gradient(135deg, #0d5962, #1a767e 65%, #2aa5a8);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.calendar-event-modal-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.calendar-event-modal-title {\n  margin: 0.35rem 0 0;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.calendar-event-modal-title-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: #9df0d0;\n  box-shadow: 0 0 0 3px rgba(157, 240, 208, 0.17);\n}\n\n.calendar-event-modal-subtitle {\n  margin: 0.4rem 0 0;\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.calendar-event-modal-header-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-top: 0.9rem;\n}\n\n.calendar-event-modal-status,\n.calendar-event-modal-projects {\n  padding: 0.24rem 0.58rem;\n  border: 1px solid rgba(255, 255, 255, 0.26);\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.13);\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.calendar-event-modal-close {\n  position: absolute;\n  top: 1.2rem;\n  right: 1.25rem;\n  width: 2.1rem;\n  height: 2.1rem;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.13);\n  color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n}\n\n.calendar-event-modal-close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.calendar-event-modal-body {\n  padding: 1.25rem 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.calendar-event-modal-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.calendar-event-modal-list-item {\n  padding: 1rem;\n  background: linear-gradient(135deg, #fff, #f8fbfb);\n  border: 1px solid #e2ebeb;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(16, 82, 88, 0.04);\n}\n\n.calendar-event-modal-item-topline {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n}\n\n.calendar-event-modal-item-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.calendar-event-modal-item-num {\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 9px;\n  background: #e9f7f4;\n  color: #167169;\n  font-size: 0.68rem;\n  font-weight: 800;\n}\n\n.calendar-event-modal-item-title {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #1b2b3a;\n}\n\n.calendar-event-modal-item-status {\n  margin-left: auto;\n  padding: 0.18rem 0.48rem;\n  border-radius: 99px;\n  background: #eaf8f1;\n  color: #15805f;\n  font-size: 0.67rem;\n  font-weight: 700;\n}\n\n.calendar-event-modal-item-meta {\n  margin-top: 0.35rem;\n  font-size: 0.8rem;\n  color: #6b7280;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.calendar-event-modal-item-company {\n  font-weight: 600;\n}\n\n.calendar-event-modal-item-code {\n  color: #0d9488;\n}\n\n.calendar-event-modal-item-cert {\n  margin-top: 0.35rem;\n  font-size: 0.75rem;\n  color: #4b5563;\n}\n\n.calendar-event-modal-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 0.9rem;\n  margin: 0.75rem 0 0;\n  padding-top: 0.7rem;\n  border-top: 1px solid #edf1f2;\n  font-size: 0.74rem;\n  color: #687684;\n}\n\n.calendar-event-modal-item-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.8rem;\n}\n\n.calendar-event-modal-process-link,\n.calendar-event-modal-edit-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.42rem 0.7rem;\n  border-radius: 8px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\n.calendar-event-modal-process-link {\n  border: 1px solid #1a767e;\n  background: #1a767e;\n  color: #fff;\n}\n\n.calendar-event-modal-edit-link {\n  border: 1px solid #a7dce0;\n  background: #fff;\n  color: #14737b;\n}\n\n.calendar-event-modal-process-link:hover,\n.calendar-event-modal-edit-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(13, 89, 98, 0.16);\n}\n\n.calendar-event-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e8eef0;\n}\n\n@media (max-width: 576px) {\n  .calendar-event-modal-backdrop { padding: 0.75rem; }\n  .calendar-event-modal-header { padding: 1.2rem 3.7rem 1.05rem 1.1rem; }\n  .calendar-event-modal-body { padding: 1rem 1.1rem; }\n  .calendar-event-modal-title { font-size: 1.12rem; }\n}\n\n/* Dropdown for hidden events (positioned via portal) */\n.calendar-more-dropdown {\n  position: fixed;\n  z-index: 1050;\n  min-width: 180px;\n  max-width: 280px;\n  max-height: 280px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  padding: 0.35rem 0;\n}\n\n.calendar-more-dropdown-title {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #6b7280;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 0.25rem;\n}\n\n.calendar-more-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.4rem 0.75rem;\n  border: none;\n  background: none;\n  font-size: 0.8rem;\n  color: #374151;\n  text-align: left;\n  cursor: pointer;\n  gap: 0.35rem;\n  border-left: 3px solid transparent;\n}\n\n.calendar-more-dropdown-item:hover {\n  background: #f3f4f6;\n}\n\n.calendar-more-dropdown-item .event-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.calendar-more-dropdown-item .event-count {\n  flex-shrink: 0;\n  padding: 0.1rem 0.35rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.calendar-placeholder {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: #6b7280;\n}\n\n/* ── List View ─────────────────────────────────────────────── */\n.calendar-list-view {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.5rem 0 2rem;\n}\n\n.calendar-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  color: #9ca3af;\n  gap: 0.75rem;\n}\n\n.calendar-list-empty-icon {\n  opacity: 0.4;\n}\n\n.calendar-list-empty-text {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.calendar-list-month-group {\n  margin-bottom: 1.5rem;\n}\n\n.calendar-list-month-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f8f9fa;\n  padding: 0.4rem 1rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.calendar-list-day-group {\n  display: flex;\n  align-items: flex-start;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.calendar-list-day-label {\n  flex: 0 0 90px;\n  padding: 0.6rem 0.75rem 0.6rem 1rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.calendar-list-day-events {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.4rem 1rem 0.4rem 0;\n}\n\n.calendar-list-event-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.35rem 0.6rem;\n  border-radius: 6px;\n  border: none;\n  background: var(--ev-bg, #f3e8ff);\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n  transition: filter 0.12s;\n  border-left: 3px solid var(--ev-color, #7c3aed);\n}\n\n.calendar-list-event-row:hover {\n  filter: brightness(0.96);\n}\n\n.calendar-list-event-dot {\n  flex: 0 0 8px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ev-color, #7c3aed);\n}\n\n.calendar-list-event-label {\n  flex: 0 0 auto;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--ev-color, #7c3aed);\n  white-space: nowrap;\n  background: transparent;\n}\n\n.calendar-list-event-title {\n  flex: 1;\n  font-size: 0.82rem;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.calendar-list-event-count {\n  flex: 0 0 auto;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--ev-color, #7c3aed);\n  background: transparent;\n  white-space: nowrap;\n}\n\n/* ----- Week view: max height follows calendar-main; body fills and overflows ----- */\n.calendar-week-view {\n  --week-grid-height: 2304px; /* 48 slots × 48px for 24h in 30-min increments */\n  flex: 1 1 0;\n  min-height: 0;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.calendar-week-header {\n  display: flex;\n  flex-shrink: 0;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fafafa;\n  z-index: 2;\n  position: relative;\n  /* Match week-body width: reserve space for vertical scrollbar so day columns align */\n  padding-right: var(--scrollbar-gutter-width, 17px);\n  box-sizing: border-box;\n}\n\n.calendar-week-time-col {\n  width: 52px;\n  min-width: 52px;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e7eb;\n  padding: 0.5rem 0.25rem;\n  font-size: 0.75rem;\n  color: #6b7280;\n  text-align: right;\n}\n\n.calendar-week-day-col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 0.25rem;\n  border-right: 1px solid #e5e7eb;\n  gap: 0.15rem;\n}\n\n.calendar-week-day-col:last-child {\n  border-right: none;\n}\n\n.calendar-week-day-col.today {\n  background: #ecfdf5;\n}\n\n.calendar-week-day-name {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.calendar-week-day-num {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.calendar-week-day-col.today .calendar-week-day-num {\n  color: var(--tblr-primary, #0d9488);\n}\n\n/* All-day row */\n.calendar-week-allday {\n  display: flex;\n  flex-shrink: 0;\n  min-height: 36px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.calendar-week-allday-col {\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 0.25rem 4px;\n  gap: 0.2rem;\n}\n\n.calendar-week-event-allday {\n  width: 100%;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  border-left: 3px solid;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Week body: full height of calendar-week-view so week-view overflows here (scroll inside) */\n.calendar-week-body {\n  flex: 1 1 0;\n  min-height: 200px;\n  display: flex;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: auto;\n  background: #fff;\n  align-items: flex-start;\n  -webkit-overflow-scrolling: touch;\n  /* Reserve space for scrollbar so header and body column widths match */\n  scrollbar-gutter: stable;\n  box-sizing: border-box;\n}\n\n.calendar-week-body > .calendar-week-time-col {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  height: var(--week-grid-height);\n  min-height: var(--week-grid-height);\n}\n\n.calendar-week-time-slot {\n  height: 96px; /* 2 × 30-min slots to align with grid */\n  min-height: 96px;\n  padding-right: 0.35rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n\n.calendar-week-time-slot .calendar-week-time-label {\n  font-size: 0.7rem;\n  color: #9ca3af;\n}\n\n.calendar-week-allday .calendar-week-time-label {\n  font-size: 0.7rem;\n  color: #9ca3af;\n  padding: 0.25rem 0.35rem 0 0;\n}\n\n.calendar-week-grid {\n  flex: 1;\n  min-width: 0;\n  height: var(--week-grid-height);\n  min-height: var(--week-grid-height);\n  flex-shrink: 0;\n  display: flex;\n  position: relative;\n}\n\n.calendar-week-day-grid {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e5e7eb;\n}\n\n.calendar-week-day-grid:last-child {\n  border-right: none;\n}\n\n.calendar-week-slot {\n  height: 48px;\n  min-height: 48px;\n}\n\n/* Full-width 30-min separators: one line from time col across all day columns */\n.calendar-week-separators {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--week-grid-height);\n  pointer-events: none;\n  z-index: 0;\n  background: repeating-linear-gradient(\n    to bottom,\n    transparent 0,\n    transparent 47px,\n    #e5e7eb 47px,\n    #e5e7eb 48px\n  );\n}\n\n.calendar-week-day-grid.today .calendar-week-slot {\n  background: #fafafa;\n}\n\n/* Events overlay – full content height so it scrolls with the grid */\n.calendar-week-events-layer {\n  position: absolute;\n  top: 0;\n  left: 52px;\n  right: 0;\n  height: var(--week-grid-height);\n  pointer-events: none;\n}\n\n.calendar-week-events-layer > * {\n  pointer-events: auto;\n}\n\n.calendar-week-event-timed {\n  position: absolute;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  border-left: 3px solid;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  cursor: pointer;\n  pointer-events: auto;\n  box-sizing: border-box;\n  /* Inset by 2px horizontal / 1px vertical so events stay inside grid (set via inline left/top/width/height) */\n}\n\n.calendar-week-event-title {\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.calendar-week-event-time {\n  font-size: 0.65rem;\n  color: #4b5563;\n  white-space: nowrap;\n}\n\n/* Current time line – wrapper matches events layer so % positioning is correct */\n.calendar-week-now-line-wrapper {\n  position: absolute;\n  top: 0;\n  left: 52px;\n  right: 0;\n  height: var(--week-grid-height);\n  pointer-events: none;\n  z-index: 2;\n}\n\n.calendar-week-now-line {\n  position: absolute;\n  height: 2px;\n  background: #dc2626;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.calendar-week-now-line::before {\n  content: '';\n  position: absolute;\n  left: -6px;\n  top: -3px;\n  width: 8px;\n  height: 8px;\n  background: #dc2626;\n  border-radius: 50%;\n}\n\n/* ── Date cell: quick-add button ── */\n.calendar-cell-date-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n  min-height: 20px;\n}\n\n.calendar-cell-date-row .calendar-cell-date {\n  align-self: auto;\n  margin-bottom: 0;\n}\n\n.calendar-cell-add-btn {\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n  background: none;\n  border: 1.5px solid #7c3aed;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #7c3aed;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.calendar-grid-cell:hover .calendar-cell-add-btn {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.calendar-cell-add-btn:hover {\n  background: #7c3aed;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
